import { DOCUMENT } from "@angular/common";
import { inject, InjectionToken } from "@angular/core";

export const WINDOW = new InjectionToken<Window> ('Window',{
    factory:() =>inject(DOCUMENT).defaultView!
})
export const LOCATION = new InjectionToken<Location>('Location',{
    factory:() =>inject(WINDOW).location
})